
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getPaidInfo, getPaidList } from '@/api/task/withdraw'
import { getChildDetail } from '@/api/order/cashOrder'
import { jsonToObjArr } from '@/utils'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import detail from './payoutWithdrawDetail.vue'
import setPaidInfo from './cash-paid-info.vue'
@Component({
  name: 'payoutDetail',
  components: {
    detail,
    setPaidInfo
  }
})
export default class extends Vue {
  @Prop({ required: true }) ordernumber!: number
  @Prop({ required: true, default: [] }) orderList!: any[]
  private orderStatusList: any[] = []
  private WithdrawList: any[] = []
  private dialogVisible: boolean = false
  private currentInfo: any = {}
  private action: string = ''

  private openDialog (action: string, param: any) {
    this.action = action
    this.currentInfo = param
    this.currentInfo.status_display = this.orderStatusList[param.status].text
    this.dialogVisible = true
  }

  private hashJump (row) {
    if (row.payment_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    } else if (row.payment_type === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    }
  }

  private closeDialog (is: boolean) {
    this.dialogVisible = false
    this.currentInfo = null
    if (is) {
      this.getPaidList()
      this.$emit('refresh')
    }
  }

  private async getPaidInfo (ordernumber: string) {
    const data: any = {
      ordernumber: ordernumber
    }
    await getPaidInfo(data).then((res: any) => {
      this.$message({
        message: 'query successfully!',
        type: 'success'
      })
      this.getPaidList()
    })
  }

  private async getPaidList () {
    const data: any = {
      ordernumber: this.ordernumber
    }
    await getChildDetail(data).then((res: any) => {
      this.WithdrawList = res
    })
  }

  private async init () {
    this.orderStatusList = await AppModule.GetOrderStatusList()
  }

  @Watch('orderList')
  private onOrderListChange () {
    this.WithdrawList = this.orderList
  }
  mounted () {
    this.init()
  }
}
